import { ApiEndpoint } from "../types/ApiTypes";

export const SystemConfigApi: Record<string, ApiEndpoint> = {
    GetConfig: {
        title: "시스템 설정 조회",
        method: "POST",
        url: "/SystemConfig/GetConfig",
    },
    SetConfig: {
        title: "시스템 설정 저장",
        method: "POST",
        url: "/SystemConfig/SetConfig",
    },
};
